// extracted by mini-css-extract-plugin
export var excerpt = "styles-module--excerpt--a+lPS";
export var arrow = "styles-module--arrow--46VNo";
export var wrapper = "styles-module--wrapper--XmFV1";
export var storyblokWrapper = "styles-module--storyblokWrapper--IfvBM";